import { render, staticRenderFns } from "./v-mod-ranking.vue?vue&type=template&id=566c212a"
import script from "./v-mod-ranking.vue?vue&type=script&lang=js"
export * from "./v-mod-ranking.vue?vue&type=script&lang=js"
import style0 from "./v-mod-ranking.vue?vue&type=style&index=0&id=566c212a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports